/* Steffie's -- Referral card
   Copy-to-clipboard for the code and the link, plus the OS share sheet where the
   browser offers one. Everything here is progressive enhancement: the code is
   server-rendered and the text/email/WhatsApp links are plain hrefs, so the card
   still works with JS off. */
(function(){
  if (window.__steffieReferralInit) return;
  window.__steffieReferralInit = true;

  function copy(text){
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function(resolve, reject){
      var field = document.createElement('textarea');
      field.value = text;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();
      field.setSelectionRange(0, 99999);
      var ok = false;
      try { ok = document.execCommand('copy'); } catch(e){}
      document.body.removeChild(field);
      ok ? resolve() : reject();
    });
  }

  function flash(btn, message){
    if (btn.dataset.refResting == null) btn.dataset.refResting = btn.textContent;
    btn.textContent = message;
    btn.classList.add('is-copied');
    clearTimeout(btn.__refTimer);
    btn.__refTimer = setTimeout(function(){
      btn.textContent = btn.dataset.refResting;
      btn.classList.remove('is-copied');
    }, 1800);
  }

  function init(){
    document.querySelectorAll('[data-ref-copy]').forEach(function(btn){
      if (btn.__refBound) return;
      btn.__refBound = true;
      btn.addEventListener('click', function(){
        var value = btn.getAttribute('data-ref-copy');
        var done = btn.getAttribute('data-ref-copied') || 'Copied';
        copy(value).then(
          function(){ flash(btn, done); },
          function(){ flash(btn, value); }  /* clipboard blocked -- show it so she can select it */
        );
      });
    });

    /* The share sheet only exists on some devices; reveal the button when it does. */
    document.querySelectorAll('[data-ref-share]').forEach(function(btn){
      if (!navigator.share) return;
      btn.hidden = false;
      if (btn.__refBound) return;
      btn.__refBound = true;
      btn.addEventListener('click', function(){
        navigator.share({
          title: btn.getAttribute('data-ref-share-title') || '',
          text: btn.getAttribute('data-ref-share-text') || '',
          url: btn.getAttribute('data-ref-share-url') || ''
        }).catch(function(){ /* she dismissed the sheet */ });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
